import React from 'react';
import { Moment } from 'moment';
import ResponseBox from 'commons/src/components/responseMessages/ResponseBox';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { DayUsageHours } from 'commons/src/models/commonTypeScript';
import { IaqInsightData, ReportSensorThresholds } from '../../../models/common';
import { SingleSensorView } from './components/SingleSensorView';
import styles from './SensorsView.module.scss';

export type SensorsViewProps = {
    sensorReports: { [sensor: string]: IaqInsightData };
    thresholds: { [sensor: string]: ReportSensorThresholds };
    from: Moment;
    to: Moment;
    usageHours: { [day: string]: DayUsageHours };
    timeZone: string;
};

const SensorsView: React.FC<SensorsViewProps> = ({ sensorReports, thresholds, from, to, usageHours, timeZone }) => {
    const availableSensors = Object.keys(sensorReports)
        .filter(sensor => {
            const sensorData = sensorReports[sensor];
            const sensorThreshold = thresholds[sensor];
            return sensorData && sensorThreshold;
        })
        .sort((sensorA, sensorB) => sensorA.localeCompare(sensorB)) as SensorTypes[];

    if (availableSensors.length === 0) {
        return <ResponseBox text="NotEnoughData" />;
    }

    return (
        <>
            {availableSensors.map((sensor, index) => (
                <React.Fragment key={`sensor-${sensor}`}>
                    {index > 0 && <div className={styles.divider} />}
                    <SingleSensorView
                        sensor={sensor}
                        sensorData={sensorReports[sensor]}
                        sensorThreshold={thresholds[sensor]}
                        from={from}
                        to={to}
                        usageHours={usageHours}
                        timeZone={timeZone}
                    />
                </React.Fragment>
            ))}
        </>
    );
};

export default SensorsView;
